import React from "react";
import { PrefilterSummaryCard } from "../../../Pages/ApplicationBlock/RecordsViewRenderer/Desktop/NewDesktopRecordviewRenderer";
import { getFieldIcon } from "../../../utils/getFieldIcon";
import MaterialIcon from "../MaterialIcon";
import { getLabelNameForTheJobMapping } from "./Utils";

const comparisonKeys = [
  "lookup_field_map",
  "sm_id",
  "name",
  "entity_id",
  "detailsview_id",
  "recordsview_id",
  "telegram_template_id",
  "email_template_id",
  "sms_template_id",
  "googledoc_template_id",
  "wa_template_id",
  "slack_template_id",
  "telegram_group_ids",
  "slack_channel_ids",
  "doc_template_ids",
  "document_template_id",
  "light_lookup",
  "mongo_template",
  "system_activity_id",
  "exceldoc_template_id",
  "pro_code_id",
  "gateway",
  "grid_id",
  "ocr_template_id",
  "pre_filter",
  "rdbms_form_id",
  "http_template_id",
  "from_email_connector",
  "statechange_on_error"
];

const SelectParamsReadOnly = ({ label, data, params, keyName }) => {
  const renderReadOnlyItem = (item, index) => {
    const compareId = getCompareId(item);
    if (compareId === params[keyName]) {
      return (
        <div className="post_activity_value" key={item.id + index}>
          {getItemDisplay(item)}
        </div>
      );
    }
    return null;
  };

  const getCompareId = (item) => {
    if (comparisonKeys.includes(keyName)) {
      return item.id;
    }
    return item.activity_id || item.name || "";
  };

  const getItemDisplay = (item) => {
    return item.table_name || item.name || item.display || item.title || item.label;
  };

  return (
    <div className="d_flex align_center">
      <div className="post_activity_key">{label} :&nbsp;</div>
      {data?.map(renderReadOnlyItem)}
    </div>
  );
};
const CheckBoxtParamsReadOnly = ({ label, params, keyName }) => {
  return (
    <div className="d_flex">
      <div className="post_activity_key">{label} : &nbsp;</div>
      {params[keyName] ? "Yes" : "No"}
    </div>
  );
};
const PreFilterParamsReadOnly = ({ params, keyName, allFieldsObject }) => {
  return (
    <div className="d_flex gap_2 flex_wrap">
      {params[keyName].filters.map((prefilter, index) => (
        <PrefilterSummaryCard key={index} prefilter={prefilter} tableObj={allFieldsObject} />
      ))}
    </div>
  );
};

const MultiSelectParamsReadOnly = ({ label, data, params }) => {
  const groupName = (itemId) => {
    const item = data.find((obj) => obj.id === itemId);
    return item ? item.name : "";
  };

  return (
    <div className="d_flex">
      <div className="post_activity_key">{label} :&nbsp;</div>
      {params?.map((item, index) => (
        <div className="post_activity_value gap_2" key={item.id + index}>
          {groupName(item)} ,
        </div>
      ))}
    </div>
  );
};

const VariableMappingReadOnly = ({ params, allFieldsObject, jobTemplateName, keyName }) => {
  // Filter out mappings that don't have values assigned
  const filteredParams = params.filter((data) => {
    return data.value || data.type === "manual" || data.type === "self" || data.type === "logged_in_manager";
  });

  // If no valid mappings exist, don't render anything
  if (filteredParams.length === 0) {
    return null;
  }

  // Get section heading for make_http_request using existing utility function
  const sectionHeading = jobTemplateName === "make_http_request" ? getLabelNameForTheJobMapping(keyName) : null;

  return (
    <>
      {sectionHeading && <div className="builder_label">{sectionHeading}</div>}
      <table className="post_activity_table">
        <thead>
          <tr>
            <th>Key</th>
            <th>Type</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {filteredParams.map((data, index) => {
            const keyFieldName = allFieldsObject.current[data?.key]?.display || data?.key || "";
            if (keyFieldName.includes("Activity Performed")) {
              return null;
            }
            return (
              <tr key={data.key + index}>
                <th>
                  <div className="d_flex g_8 align_center">
                    {allFieldsObject.current[data.key]?.field_type && (
                      <MaterialIcon
                        name={getFieldIcon(allFieldsObject.current[data.key].field_type)}
                        className="font_size_xlarge"
                      />
                    )}
                    <span>{allFieldsObject.current[data.key]?.display || data.key}</span>
                  </div>
                </th>
                <th>{data.type}</th>
                <th>
                  {data.type === "mapped" || data.type === "logged_in_user" ? (
                    <div>
                      {data.value === ""
                        ? "select field"
                        : allFieldsObject.current[data.value]?.display || allFieldsObject.current[data.value]?.name}
                    </div>
                  ) : (
                    <div>{data.value}</div>
                  )}
                </th>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};

export {
  CheckBoxtParamsReadOnly,
  MultiSelectParamsReadOnly,
  PreFilterParamsReadOnly,
  SelectParamsReadOnly,
  VariableMappingReadOnly
};
